<template>
  <ErrorPage v-if="!canManagePortal" type="forbidden" />
  <ErrorPage v-else-if="isNotFound" type="notFound" />
  <LoadingWrapper v-else :state="status">
    <div
      v-if="portalUrl"
      class="bg-primary-container flex min-h-dvh w-full flex-col items-center justify-center gap-8 px-8 py-10 text-black"
    >
      <div class="bg-surface-container-lowest shadow-4 rounded-extra-large w-[min(68dvh,86vw)] p-8">
        <QRCode :link="portalUrl" />
      </div>
      <p
        class="text-on-primary-container max-w-full text-center text-[clamp(1.25rem,2.5vw,2.75rem)] leading-tight break-all"
      >
        {{ portalUrl }}
      </p>
    </div>
    <p v-else class="text-body-large px-8 py-16">{{ $t('portal.link.empty') }}</p>
  </LoadingWrapper>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { usePermission } from '@/core/composables/use-permission'
  import { Permission } from '@/core/models/user'
  import ErrorPage from '@/modules/app/pages/ErrorPage.vue'
  import { useTeamPortal } from '../composables/use-team-portal'
  import QRCode from '@/core/components/qr-code/QRCode.vue'

  const route = useRoute()
  const { can } = usePermission()
  const canManagePortal = computed(() => can(Permission.PORTAL_MANAGE))
  const teamId = computed(() => route.params.teamId as string)

  const { portalUrl, status, isNotFound } = useTeamPortal(teamId, {
    autoload: canManagePortal.value,
  })
</script>
